export default {
  isEmpty(obj: object) {
    return 0 === Object.values(obj).length;
  }
}
